import React from "react";
import { ReactComponent as DollarIcon } from "@/assets/img/dollar_icon.svg";
import { ReactComponent as RielIcon } from "@/assets/img/riel_icon.svg";
import { ReactComponent as GoldIcon } from "@/assets/img/gold_icon.svg";
import { numberFormatter } from "@/util/formatter";
import styles from "./styles.module.scss";

export default function CurrencyRoundCard({
  currency = "riel",
  balance,
  ...others
}) {
  const wrapperClassName =
    currency === "riel"
      ? styles.red
      : currency === "gold"
      ? styles.gold
      : styles.orange;

  const currencyIcon =
    currency === "riel" ? (
      <RielIcon className={styles.rielIconTotal} />
    ) : currency === "gold" ? (
      <GoldIcon className={styles.goldIconTotal} />
    ) : (
      <DollarIcon className={styles.dollarIconTotal} />
    );

  return (
    <div
      className={`${styles.currencyCardWrapper} ${wrapperClassName}`}
      {...others}>
      {currencyIcon}
      <span className={styles.balance}>
        {numberFormatter(balance, currency === "riel" ? 0 : 2)}
      </span>
    </div>
  );
}
